import { ModalImages } from '../../components/white-label/modals/ModalSelectImage';
import { apiGoogleStorage } from '../api-google-storage';
import { apiSensedia } from '../api-sensedia';

let apiWl = apiSensedia;

if (process.env.NODE_ENV != 'development') {
  apiWl = apiSensedia;
}

type CorretorImage = {
  fileName: string | null;
  signedUrl: string | null;
};

export const getStorageToken = async () => {
  const {
    data: { access_token }
  } = await apiWl.get('/imagens/token');

  return access_token;
};

export const sendImageToBucket = async ({
  data,
  pathName
}: {
  data: string;
  pathName: string;
}) => {
  try {
    const access_token = await getStorageToken();
    const bodyBlob = await (await fetch(data)).blob();
    const response = await apiGoogleStorage.post(
      `/${process.env.REACT_APP_WHITE_LABEL_BUCKET}/o?uploadType=media&name=${pathName}`,
      bodyBlob,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          'Content-Type': 'image/jpeg'
        }
      }
    );
    console.log(response.data);
    return response.data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const listAllImages = async (): Promise<ModalImages[]> => {
  const response = await apiWl.get('/corretores/000/imagens');
  return response.data.map((image: CorretorImage) => ({
    src: image.signedUrl,
    path: image.fileName,
    alt: image.fileName
  }));
};
